/* BG COM 04/10/2026 (vitesse) : sorti tel quel de snippets/bgcom-chat-launcher.liquid (bloc <script> en ligne), chargé en defer.
   04/10/2026 (vitesse r4, jury CWV) : l'autocollant n'apparaît qu'après la première action du visiteur (voir « armed ») ; la feuille
   bgcom-chat-launcher.css arrive sans bloquer la page (media=print puis all) : rien ne s'affiche avant qu'elle soit appliquée (whenCss).
   04/10/2026 (vitesse r5.2, jury) : 1) produits et machine du chat lus dans sections/bgcom-chat-data (chatData) juste avant de charger
   bgcom-chat.js, puis recopiés dans #bgcom-chat-config (plus de all_products dans les pages : le JSON des Web Pixels des fiches ne contient
   plus ces produits ni leur « vendor ») ; 2) la pastille n'apparaît qu'après le load de la page (au plus tard 12 s) : sa tête et
   l'autocollant (images visibles, donc en priorité haute) ne partent plus pendant la photo principale (ordinateur). */
  (function(){
    var a = document.querySelector('[data-bgcom-chat]');
    if(!a || a.__bgchInit) return;
    a.__bgchInit = true;
    var root = document.documentElement, LABEL = a.getAttribute('aria-label');
    var mm = function(q){ return window.matchMedia ? window.matchMedia(q) : { matches:false }; };
    var wideQ = mm('(min-width: 1870px) and (hover: hover)');   /* l'autocollant tient dans la marge droite */
    var deskQ = mm('(min-width: 990px) and (hover: hover)');
    var intro = false, hovering = false, ticking = false, hoverT, shown = false, inboxUnread = false, ownUnread = false, loading = false;
    /* 04/10 r4 (jury CWV) : sur ordinateur, l'autocollant (≈ 72 700 px², plus grand que le contenu affiché en haut des pages machines et
       masquages) devenait l'élément LCP (469 ms contre 199 ms en ligne, 6,6 s sans Inbox). Il ne se montre plus (aperçu de 4,5 s,
       haut de page ≥ 1870 px, survol) qu'une fois la page chargée ET après la première action du visiteur (pointerdown, keydown,
       touchstart, molette, défilement) : le navigateur a alors figé le LCP. La pastille, le focus et l'ARIA ne changent pas. */
    var armed = false, acted = false, loaded = document.readyState === 'complete', introWanted = false, introT;
    var ACTS = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
    function onAct(e){
      if(armed || (e && e.isTrusted === false)) return;   /* événements simulés (scripts qui relancent un « scroll ») : ignorés */
      acted = true;
      if(e && e.target && e.target.nodeType === 1 && a.contains(e.target)) introWanted = false;   /* il ouvre le chat : pas d'aperçu */
      arm();
    }
    function arm(){
      if(armed || !acted || !loaded) return;
      armed = true;
      ACTS.forEach(function(t){ window.removeEventListener(t, onAct, true); });
      window.removeEventListener('scroll', onAct);
      if(introWanted) introT = setTimeout(startIntro, 700);   /* après le premier geste : un défilement en cours n'a pas d'aperçu */
      mode();
    }
    ACTS.forEach(function(t){ window.addEventListener(t, onAct, { capture:true, passive:true }); });
    window.addEventListener('scroll', onAct, { passive:true });   /* défilement de la page seulement (pas celui d'un carrousel) */
    if(!loaded) window.addEventListener('load', function(){ loaded = true; arm(); }, { once:true });
    function startIntro(){
      if(!introWanted) return;
      introWanted = false;
      if(!deskQ.matches || wideQ.matches || hovering || loading || (window.scrollY || 0) >= 40 || ours() || a.classList.contains('is-chat-open')) return;
      try{ sessionStorage.setItem('bgcom-chat-intro', '1'); }catch(_){}
      intro = true; mode();
      setTimeout(function(){ intro = false; mode(); }, 4500);
    }
    /* 04/10 (vitesse) : autocollant et tête en loading=lazy (jamais téléchargés sur téléphone, où la pastille est masquée) ;
       sur ordinateur, on les demande au load (après la photo principale) pour qu'ils soient prêts quand la pastille arrive. */
    (function(){
      function warm(){ if(!deskQ.matches) return; [].forEach.call(a.querySelectorAll('img[loading="lazy"]'), function(im){ im.loading = 'eager'; }); }
      if(document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once:true });
    })();
    var CFG = {}; try{ CFG = JSON.parse((document.getElementById('bgcom-chat-config') || {}).textContent || '{}'); }catch(_){}
    function chat(){ return document.querySelector('shopify-chat'); }
    function inboxReady(){ var c = chat(); return !!(c && typeof c.show === 'function'); }
    function ours(){ return !!(window.BgcomChat && window.BgcomChat.isOpen && window.BgcomChat.isOpen()); }

    function mode(){
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0, cur = a.classList.contains('is-big');
      var wide = armed && wideQ.matches && (cur ? y < 320 : y < 200);
      a.classList.toggle('is-big', !!(armed && (wide || intro || (hovering && deskQ.matches))));
      /* pendant l'aperçu de 4,5 s, l'autocollant laisse passer les clics (la pastille dessous reste cliquable) */
      a.classList.toggle('is-intro', !!(intro && !wide && !hovering));
    }
    window.addEventListener('scroll', function(){
      if(intro && (window.scrollY || 0) > 40) intro = false;
      if(!ticking){ ticking = true; requestAnimationFrame(mode); }
    }, { passive:true });
    [wideQ, deskQ].forEach(function(q){ if(q.addEventListener) q.addEventListener('change', mode); else if(q.addListener) q.addListener(mode); });
    /* survol de la pastille (ordinateur) : l'autocollant ressort ; il reste tant que la souris est sur l'un ou l'autre */
    a.addEventListener('pointerenter', function(e){ if(e.pointerType !== 'mouse') return; clearTimeout(hoverT); hovering = true; mode(); });
    a.addEventListener('pointerleave', function(e){ if(e.pointerType !== 'mouse') return; clearTimeout(hoverT); hoverT = setTimeout(function(){ hovering = false; mode(); }, 220); });

    /* point « non lu » : réponse de l'équipe dans Inbox, ou réponse du panneau arrivée chat fermé */
    function unread(){
      var on = inboxUnread || ownUnread;
      a.classList.toggle('has-unread', on);
      a.setAttribute('aria-label', on ? LABEL + ', nouvelle réponse' : LABEL);
    }
    window.BgcomChatLauncher = { el:a, setOwnUnread:function(v){ ownUnread = !!v; unread(); }, inboxUnread:function(){ return inboxUnread; } };

    /* 04/10 r5.2 : produits et machine du chat (sections/bgcom-chat-data, même JSON qu'avant), recopiés dans #bgcom-chat-config avant
       bgcom-chat.js (il lit la configuration à son chargement). Jamais bloquant : sans réponse en 6 s, le chat se charge sans eux (il ne
       montre alors aucune carte produit, comme avant pour un produit absent). Gardé 10 min dans sessionStorage (une requête par visite). */
    var dataP = null, DKEY = 'bgcom-chat-data-v1';
    function chatData(){
      if(dataP) return dataP;
      dataP = new Promise(function(res){
        function put(d){
          try{
            if(d && typeof d === 'object' && d.products){
              var n = document.getElementById('bgcom-chat-config'), c = JSON.parse((n && n.textContent) || '{}');
              c.products = d.products; c.machine = d.machine || null;
              if(n) n.textContent = JSON.stringify(c);
            }
          }catch(_){}
          res();
        }
        var c0 = null; try{ c0 = JSON.parse(sessionStorage.getItem(DKEY) || 'null'); }catch(_){}
        if(c0 && c0.d && Date.now() - (+c0.t || 0) < 600000){ put(c0.d); return; }
        if(!CFG.data || !window.fetch){ res(); return; }
        var to = setTimeout(res, 6000);
        fetch(CFG.data, { credentials:'same-origin' }).then(function(r){ return r.ok ? r.text() : ''; }).then(function(h){
          var m = /<script[^>]*data-bgcom-chat-data[^>]*>([\s\S]*?)<\/script>/.exec(h || ''), d = null;
          try{ d = m ? JSON.parse(m[1]) : null; }catch(_){ d = null; }
          if(d && d.products){ try{ sessionStorage.setItem(DKEY, JSON.stringify({ t:Date.now(), d:d })); }catch(_){} }
          clearTimeout(to); put(d);
        }, function(){ clearTimeout(to); res(); });
      });
      return dataP;
    }

    /* panneau Mister Paint (assets/bgcom-chat.css + .js) : chargé au repos de la page ou au premier clic */
    var bundle = null, cssOk = false;
    function apiOk(){ return !!(window.BgcomChat && window.BgcomChat.ready && cssOk); }
    function loadBundle(){
      if(apiOk()) return Promise.resolve();
      if(bundle) return bundle;
      bundle = new Promise(function(res, rej){
        if(!CFG.css || !CFG.js || !window.Promise){ rej(new Error('config')); return; }
        var left = 2, t = setTimeout(function(){ rej(new Error('timeout')); }, 9000);
        function one(){ if(--left) return; clearTimeout(t); if(apiOk()) res(); else rej(new Error('api')); }
        function fail(){ clearTimeout(t); rej(new Error('load')); }
        var l = document.querySelector('link[data-bgcom-chat-css]');
        if(l && cssOk){ one(); } else {
          if(l) l.remove();
          l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CFG.css; l.setAttribute('data-bgcom-chat-css', '');
          l.onload = function(){ cssOk = true; one(); }; l.onerror = fail; document.head.appendChild(l);
        }
        if(window.BgcomChat && window.BgcomChat.ready){ one(); } else {
          chatData().then(function(){
            var s = document.querySelector('script[data-bgcom-chat-js]');
            if(s) s.remove();
            s = document.createElement('script'); s.src = CFG.js; s.async = true; s.setAttribute('data-bgcom-chat-js', '');
            s.onload = one; s.onerror = fail; document.head.appendChild(s);
          });
        }
      });
      bundle.then(null, function(){ bundle = null; });   /* un nouvel essai au clic suivant */
      return bundle;
    }
    function preload(){
      var go = function(){ loadBundle().then(null, function(){}); };
      var later = function(){ setTimeout(function(){ if(window.requestIdleCallback) requestIdleCallback(go, { timeout:6000 }); else go(); }, 2500); };
      if(document.readyState === 'complete') later(); else window.addEventListener('load', later, { once:true });
    }

    /* 04/10 r4 : la feuille du bouton arrive sans bloquer la page ; le bouton reste [hidden] tant qu'elle n'est pas appliquée
       (position:fixed lue sur le bouton). Feuille introuvable au bout de 10 s : on ne montre rien, la bulle d'origine d'Inbox reste. */
    function cssOn(){ try{ return getComputedStyle(a).position === 'fixed'; }catch(_){ return true; } }
    function whenCss(cb){
      var done = false, n = 0;
      function chk(){ if(!done && cssOn()){ done = true; cb(); } return done; }
      if(chk()) return;
      var l = document.querySelector('link[data-bgcom-chat-launcher-css]');
      if(l) l.addEventListener('load', function(){ setTimeout(chk, 0); }, { once:true });
      (function poll(){ if(!chk() && ++n < 100) setTimeout(poll, 100); })();
    }

    /* la pastille apparaît : chat de l'équipe prêt, ou au bout de 6 s sans lui (notre panneau suffit) */
    /* 04/10 r5.2 : la pastille attend le load de la page (au plus tard 12 s après le démarrage de ce script) */
    var showWait = false, T0 = Date.now();
    function show(){
      if(shown) return;
      if(document.readyState !== 'complete' && Date.now() - T0 < 12000){
        if(!showWait){
          showWait = true;
          var go = function(){ showWait = false; show(); };
          window.addEventListener('load', go, { once:true });
          setTimeout(function(){ if(!shown) go(); }, 12000 - (Date.now() - T0));
        }
        return;
      }
      shown = true;
      a.hidden = false;
      a.setAttribute('role', 'button');
      a.setAttribute('aria-expanded', 'false');
      /* première page de la visite, ordinateur : l'autocollant se montre 4,5 s puis se range (après la première action, voir arm) */
      var seen = false; try{ seen = sessionStorage.getItem('bgcom-chat-intro') === '1'; }catch(_){}
      if(!seen) introWanted = true;
      if(armed && introWanted && !introT) introT = setTimeout(startIntro, 700);
      mode();
      requestAnimationFrame(function(){ requestAnimationFrame(function(){
        a.classList.add('is-on');
        try{ document.dispatchEvent(new CustomEvent('bgcom:chat-ready')); }catch(_){}   /* barre d'achat flottante : se replacer */
      }); });
      preload();
    }

    function ready(c){
      if(a.__bgchReady) return;
      a.__bgchReady = true;
      whenCss(function(){ ready2(c); });
    }
    function ready2(c){
      root.setAttribute('data-bgcom-chat-own', '');   /* 04/10 r4.3 : attribut et non classe (voir bgcom-chat-launcher.css) */
      show();

      /* garde-fou : si la bulle d'origine est encore visible (Shopify a changé son composant), on s'efface */
      setTimeout(function(){
        var sr = c.shadowRoot, act = sr && sr.querySelector('[part~="activator"], .activator');
        if(act && getComputedStyle(act).display !== 'none'){ shown = true; /* r5.2 : plus d'apparition différée */ root.removeAttribute('data-bgcom-chat-own'); a.classList.remove('is-on'); a.hidden = true; if(window.BgcomChat && window.BgcomChat.close) window.BgcomChat.close(); }
      }, 1000);

      /* chat de l'équipe ouvert : le bouton s'efface ; à la fermeture, le focus lui revient (la bulle d'origine est masquée) */
      var wasOpen = c.hasAttribute('open');
      function sync(){
        var open = c.hasAttribute('open'), mine = ours();
        a.classList.toggle('is-chat-open', open || mine);
        if(wasOpen && !open && !a.hidden && !mine){
          var ae = document.activeElement;
          if(!ae || ae === document.body || ae === c){ try{ a.focus({ preventScroll:true }); }catch(_){ a.focus(); } }
        }
        wasOpen = open;
      }
      new MutationObserver(sync).observe(c, { attributes:true, attributeFilter:['open'] });
      sync();
      /* point « réponses non lues » repris de la bulle d'origine */
      function mirror(){
        var sr = c.shadowRoot, i = sr && sr.querySelector('.activator__indicator');
        inboxUnread = !!(i && i.classList.contains('activator__indicator--active'));
        unread();
      }
      (function watch(n){
        if(c.shadowRoot){ new MutationObserver(mirror).observe(c.shadowRoot, { subtree:true, childList:true, attributes:true, attributeFilter:['class'] }); mirror(); return; }
        if(n < 40) setTimeout(function(){ watch(n + 1); }, 250);
      })(0);
    }

    /* chat de l'équipe (comportement d'avant) : show(), sinon la page Nous contacter */
    function openInbox(){
      var c = chat();
      if(!(c && typeof c.show === 'function')){ window.location.href = a.href; return; }
      try{ c.show(); }catch(_){ window.location.href = a.href; return; }
      /* le chat ne s'est pas ouvert : page Nous contacter */
      setTimeout(function(){ if(!c.open && !c.hasAttribute('open')) window.location.href = a.href; }, 1500);
    }
    function busy(on){ loading = on; a.classList.toggle('is-loading', on); if(on) a.setAttribute('aria-busy', 'true'); else a.removeAttribute('aria-busy'); }
    function openChat(e){
      if(e) e.preventDefault();
      if(loading) return;
      intro = false; introWanted = false; hovering = false; mode();
      /* l'équipe a répondu dans son chat : on l'ouvre directement */
      if(inboxUnread && inboxReady()){ openInbox(); return; }
      if(apiOk()){ if(window.BgcomChat.open() === false) openInbox(); return; }
      busy(true);
      loadBundle().then(function(){ busy(false); if(window.BgcomChat.open() === false) openInbox(); }, function(){ busy(false); openInbox(); });
    }
    a.addEventListener('click', openChat);
    a.addEventListener('keydown', function(e){ if(e.key === ' ' || e.key === 'Spacebar'){ openChat(e); } });

    /* attendre le composant de Shopify (app embed Shopify Inbox) ; sans lui, la pastille vient au bout de 6 s */
    (function wait(n){
      var c = chat();
      if(c && window.customElements && customElements.get('shopify-chat') && typeof c.show === 'function'){ ready(c); return; }
      if(n === 24) whenCss(show);
      if(n < 80) setTimeout(function(){ wait(n + 1); }, 250);
    })(0);
  })();
